import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { companyLicenseFeaturesSchema } from '../schemas/company-license-features.schema';

export function getCompanyLicenseFeatures(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.resolve(this).companyLicenseFeaturesUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(companyLicenseFeaturesSchema));
}
